define([], function() {
	return [
		{
			"display-country": "United States",
			"country": "US",
			"states": [{"state": "AL", "display-state": "Alabama"}, {
				"state": "AK",
				"display-state": "Alaska"
			}, {"state": "AS", "display-state": "American Samoa"}, {
				"state": "AZ",
				"display-state": "Arizona"
			}, {"state": "AR", "display-state": "Arkansas"}, {
				"state": "AA",
				"display-state": "Armed Forces Americas"
			}, {"state": "AE", "display-state": "Armed Forces Europe"}, {
				"state": "AP",
				"display-state": "Armed Forces Pacific"
			}, {"state": "CA", "display-state": "California"}, {
				"state": "CO",
				"display-state": "Colorado"
			}, {"state": "CT", "display-state": "Connecticut"}, {
				"state": "DE",
				"display-state": "Delaware"
			}, {"state": "FM", "display-state": "Federated States of Micronesia"}, {
				"state": "FL",
				"display-state": "Florida"
			}, {"state": "GA", "display-state": "Georgia"}, {"state": "GU", "display-state": "Guam"}, {
				"state": "HI",
				"display-state": "Hawaii"
			}, {"state": "ID", "display-state": "Idaho"}, {"state": "IL", "display-state": "Illinois"}, {
				"state": "IN",
				"display-state": "Indiana"
			}, {"state": "IA", "display-state": "Iowa"}, {"state": "KS", "display-state": "Kansas"}, {
				"state": "KY",
				"display-state": "Kentucky"
			}, {"state": "LA", "display-state": "Louisiana"}, {"state": "ME", "display-state": "Maine"}, {
				"state": "MH",
				"display-state": "Marshall Islands"
			}, {"state": "MD", "display-state": "Maryland"}, {
				"state": "MA",
				"display-state": "Massachusetts"
			}, {"state": "MI", "display-state": "Michigan"}, {
				"state": "MN",
				"display-state": "Minnesota"
			}, {"state": "MS", "display-state": "Mississippi"}, {
				"state": "MO",
				"display-state": "Missouri"
			}, {"state": "MT", "display-state": "Montana"}, {
				"state": "NE",
				"display-state": "Nebraska"
			}, {"state": "NV", "display-state": "Nevada"}, {
				"state": "NH",
				"display-state": "New Hampshire"
			}, {"state": "NJ", "display-state": "New Jersey"}, {
				"state": "NM",
				"display-state": "New Mexico"
			}, {"state": "NY", "display-state": "New York"}, {
				"state": "NC",
				"display-state": "North Carolina"
			}, {"state": "ND", "display-state": "North Dakota"}, {
				"state": "MP",
				"display-state": "Northern Mariana Islands"
			}, {"state": "OH", "display-state": "Ohio"}, {"state": "OK", "display-state": "Oklahoma"}, {
				"state": "OR",
				"display-state": "Oregon"
			}, {"state": "PW", "display-state": "Palau"}, {
				"state": "PA",
				"display-state": "Pennsylvania"
			}, {"state": "PR", "display-state": "Puerto Rico"}, {
				"state": "RI",
				"display-state": "Rhode Island"
			}, {"state": "SC", "display-state": "South Carolina"}, {
				"state": "SD",
				"display-state": "South Dakota"
			}, {"state": "TN", "display-state": "Tennessee"}, {"state": "TX", "display-state": "Texas"}, {
				"state": "UT",
				"display-state": "Utah"
			}, {"state": "VT", "display-state": "Vermont"}, {
				"state": "VI",
				"display-state": "Virgin Islands"
			}, {"state": "VA", "display-state": "Virginia"}, {
				"state": "WA",
				"display-state": "Washington"
			}, {"state": "DC", "display-state": "Washington DC"}, {
				"state": "WV",
				"display-state": "West Virginia"
			}, {"state": "WI", "display-state": "Wisconsin"}, {"state": "WY", "display-state": "Wyoming"}],
			"icon": "United-States.png"
		},
		{"states": [], "country": ""},
		{"states": [], "country": "AF", "display-country": "Afghanistan", "icon": "Afghanistan.png"},
		{"states": [], "country": "AX", "display-country": "Aland Islands", "icon": "Aland-Islands.png"},
		{"states": [], "country": "AL", "display-country": "Albania", "icon": "Albania.png"},
		{"states": [], "country": "DZ", "display-country": "Algeria", "icon": "Algeria.png"},
		{"states": [], "country": "AD", "display-country": "Andorra", "icon": "Andorra.png"},
		{"states": [], "country": "AO", "display-country": "Angola", "icon": "Angola.png"},
		{"states": [], "country": "AI", "display-country": "Anguilla", "icon": "Anguilla.png"},
		{"states": [], "country": "AG", "display-country": "Antigua And Barbuda", "icon": "Antigua-And-Barbuda.png"},
		{
			"states": [{"state": "", "display-state": "Buenos Aires"}, {
				"state": "",
				"display-state": "Buenos Aires City"
			}, {"state": "", "display-state": "Catamarca"}, {"state": "", "display-state": "Chaco"}, {
				"state": "",
				"display-state": "Chobut"
			}, {"state": "", "display-state": "Corrientes"}, {"state": "", "display-state": "C\u00f3rdoba"}, {
				"state": "",
				"display-state": "Ente R\u00edos"
			}, {"state": "", "display-state": "Formosa"}, {"state": "", "display-state": "Jujuy"}, {
				"state": "",
				"display-state": "La Pampa"
			}, {"state": "", "display-state": "La Rioja"}, {"state": "", "display-state": "Mendoza"}, {
				"state": "",
				"display-state": "Misiones"
			}, {"state": "", "display-state": "Neuqu\u00e9n"}, {
				"state": "",
				"display-state": "R\u00edo Negro"
			}, {"state": "", "display-state": "Salta"}, {"state": "", "display-state": "San Juan"}, {
				"state": "",
				"display-state": "San Luis"
			}, {"state": "", "display-state": "Santa Cruz"}, {"state": "", "display-state": "Santa Fe"}, {
				"state": "",
				"display-state": "Santiago Del Estero"
			}, {"state": "", "display-state": "Tierra del Fuego"}, {"state": "", "display-state": "Tucum\u00e1n"}],
			"country": "AR",
			"display-country": "Argentina",
			"icon": "Argentina.png"
		},
		{"states": [], "country": "AM", "display-country": "Armenia", "icon": "Armenia.png"},
		{"states": [], "country": "AW", "display-country": "Aruba", "icon": "Aruba.png"},
		{
			"states": [{"state": "ACT", "display-state": "Australian Capital Territory"}, {
				"state": "NSW",
				"display-state": "New South Wales"
			}, {"state": "NT", "display-state": "Northern Territory"}, {
				"state": "QLD",
				"display-state": "Queensland"
			}, {"state": "SA", "display-state": "South Australia"}, {"state": "Tas", "display-state": "Tasmania"}, {
				"state": "Vic",
				"display-state": "Victoria"
			}, {"state": "WA", "display-state": "Western Australia"}],
			"country": "AU",
			"display-country": "Australia",
			"icon": "Australia.png"
		},
		{"states": [], "country": "AT", "display-country": "Austria", "icon": "Austria.png"},
		{"states": [], "country": "AZ", "display-country": "Azerbaijan", "icon": "Azerbaijan.png"},
		{"states": [], "country": "BS", "display-country": "Bahamas", "icon": "Bahamas.png"},
		{"states": [], "country": "BH", "display-country": "Bahrain", "icon": "Bahrain.png"},
		{"states": [], "country": "BD", "display-country": "Bangladesh", "icon": "Bangladesh.png"},
		{"states": [], "country": "BB", "display-country": "Barbados", "icon": "Barbados.png"},
		{"states": [], "country": "BY", "display-country": "Belarus", "icon": "Belarus.png"},
		{"states": [], "country": "BE", "display-country": "Belgium", "icon": "Belgium.png"},
		{"states": [], "country": "BZ", "display-country": "Belize", "icon": "Belize.png"},
		{"states": [], "country": "BJ", "display-country": "Benin", "icon": "Benin.png"},
		{"states": [], "country": "BM", "display-country": "Bermuda", "icon": "Bermuda.png"},
		{"states": [], "country": "BT", "display-country": "Bhutan", "icon": "Bhutan.png"},
		{"states": [], "country": "BO", "display-country": "Bolivia", "icon": "Bolivia.png"},
		{
			"states": [],
			"country": "BA",
			"display-country": "Bosnia And Herzegovina",
			"icon": "Bosnia-And-Herzegovina.png"
		},
		{"states": [], "country": "BW", "display-country": "Botswana", "icon": "Botswana.png"},
		{"states": [], "country": "BV", "display-country": "Bouvet Island", "icon": "Bouvet-Island.png"},
		{
			"states": [{"state": "", "display-state": "Acre"}, {"state": "", "display-state": "Alagoas"}, {
				"state": "",
				"display-state": "Amap\u00e1"
			}, {"state": "", "display-state": "Amazonas"}, {"state": "", "display-state": "Bahia"}, {
				"state": "",
				"display-state": "Cear\u00e1"
			}, {"state": "", "display-state": "Distrito Federal"}, {
				"state": "",
				"display-state": "Esp\u00edrito Santo"
			}, {"state": "", "display-state": "Goi\u00e1s"}, {"state": "", "display-state": "Maranh\u00e3o"}, {
				"state": "",
				"display-state": "Mato Grosso"
			}, {"state": "", "display-state": "Mato Grosso do Sul"}, {
				"state": "",
				"display-state": "Minas Gerais"
			}, {"state": "", "display-state": "Paran\u00e1"}, {"state": "", "display-state": "Para\u00edba"}, {
				"state": "",
				"display-state": "Par\u00e1"
			}, {"state": "", "display-state": "Pernambuco"}, {"state": "", "display-state": "Piau\u00ed"}, {
				"state": "",
				"display-state": "Rio Grande do Norte"
			}, {"state": "", "display-state": "Rio Grande do Sul"}, {
				"state": "",
				"display-state": "Rio de Janeiro"
			}, {"state": "", "display-state": "Rond\u00f4nia"}, {"state": "", "display-state": "Roraima"}, {
				"state": "",
				"display-state": "Santa Catarina"
			}, {"state": "", "display-state": "Sergipe"}, {"state": "", "display-state": "S\u00e3o Paulo"}, {
				"state": "",
				"display-state": "Tocantins"
			}], "country": "BR", "display-country": "Brazil", "icon": "Brazil.png"
		},
		{
			"states": [],
			"country": "IO",
			"display-country": "British Indian Ocean Territory",
			"icon": "British-Indian-Ocean-Territory.png"
		},
		{"states": [], "country": "BN", "display-country": "Brunei", "icon": "Brunei.png"},
		{"states": [], "country": "BG", "display-country": "Bulgaria", "icon": "Bulgaria.png"},
		{"states": [], "country": "BF", "display-country": "Burkina Faso", "icon": "Burkina-Faso.png"},
		{"states": [], "country": "MM", "display-country": "Burma", "icon": "Burma.png"},
		{"states": [], "country": "BI", "display-country": "Burundi", "icon": "Burundi.png"},
		{"states": [], "country": "KH", "display-country": "Cambodia", "icon": "Cambodia.png"},
		{
			"display-country": "Canada",
			"country": "CA",
			"states": [{"state": "AB", "display-state": "Alberta"}, {
				"state": "BC",
				"display-state": "British Columbia"
			}, {"state": "MB", "display-state": "Manitoba"}, {
				"state": "NB",
				"display-state": "New Brunswick"
			}, {"state": "NL", "display-state": "Newfoundland"}, {
				"state": "NT",
				"display-state": "Northwest Territories"
			}, {"state": "NS", "display-state": "Nova Scotia"}, {
				"state": "NU",
				"display-state": "Nunavut"
			}, {"state": "ON", "display-state": "Ontario"}, {
				"state": "PE",
				"display-state": "Prince Edward Island"
			}, {"state": "QC", "display-state": "Quebec"}, {
				"state": "SK",
				"display-state": "Saskatchewan"
			}, {"state": "YT", "display-state": "Yukon"}],
			"icon": "Canada.png"
		},
		{"states": [], "country": "CV", "display-country": "Cape Verde", "icon": "Cape-Verde.png"},
		{"states": [], "country": "KY", "display-country": "Cayman Islands", "icon": "Cayman-Islands.png"},
		{
			"states": [],
			"country": "CF",
			"display-country": "Central African Republic",
			"icon": "Central-African-Republic.png"
		},
		{"states": [], "country": "TD", "display-country": "Chad", "icon": "Chad.png"},
		{"states": [], "country": "CL", "display-country": "Chile", "icon": "Chile.png"},
		{"states": [], "country": "CN", "display-country": "China", "icon": "China.png"},
		{"states": [], "country": "CX", "display-country": "Christmas Island", "icon": "Christmas-Island.png"},
		{
			"states": [],
			"country": "CC",
			"display-country": "Cocos (Keeling) Islands",
			"icon": "Cocos-(Keeling)-Islands.png"
		},
		{"states": [], "country": "CO", "display-country": "Colombia", "icon": "Colombia.png"},
		{"states": [], "country": "KM", "display-country": "Comoros", "icon": "Comoros.png"},
		{"states": [], "country": "CG", "display-country": "Congo", "icon": "Congo.png"},
		{
			"states": [],
			"country": "CD",
			"display-country": "Congo, The Democratic Republic Of The",
			"icon": "Congo,-The-Democratic-Republic-Of-The.png"
		},
		{"states": [], "country": "CK", "display-country": "Cook Islands", "icon": "Cook-Islands.png"},
		{"states": [], "country": "CR", "display-country": "Costa Rica", "icon": "Costa-Rica.png"},
		{"states": [], "country": "HR", "display-country": "Croatia", "icon": "Croatia.png"},
		{"states": [], "country": "CU", "display-country": "Cuba", "icon": "Cuba.png"},
		{"states": [], "country": "CW", "display-country": "Cura\u00e7ao", "icon": "Cura\u00e7ao.png"},
		{"states": [], "country": "CY", "display-country": "Cyprus", "icon": "Cyprus.png"},
		{"states": [], "country": "CZ", "display-country": "Czech Republic", "icon": "Czech-Republic.png"},
		{"states": [], "country": "CI", "display-country": "C\u00f4te d'Ivoire", "icon": "C\u00f4te-d'Ivoire.png"},
		{"states": [], "country": "DK", "display-country": "Denmark", "icon": "Denmark.png"},
		{"states": [], "country": "DJ", "display-country": "Djibouti", "icon": "Djibouti.png"},
		{"states": [], "country": "DM", "display-country": "Dominica", "icon": "Dominica.png"},
		{"states": [], "country": "DO", "display-country": "Dominican Republic", "icon": "Dominican-Republic.png"},
		{"states": [], "country": "EC", "display-country": "Ecuador", "icon": "Ecuador.png"},
		{"states": [], "country": "EG", "display-country": "Egypt", "icon": "Egypt.png"},
		{"states": [], "country": "SV", "display-country": "El Salvador", "icon": "El-Salvador.png"},
		{"states": [], "country": "GQ", "display-country": "Equatorial Guinea", "icon": "Equatorial-Guinea.png"},
		{"states": [], "country": "ER", "display-country": "Eritrea", "icon": "Eritrea.png"},
		{"states": [], "country": "EE", "display-country": "Estonia", "icon": "Estonia.png"},
		{"states": [], "country": "ET", "display-country": "Ethiopia", "icon": "Ethiopia.png"},
		{
			"states": [],
			"country": "FK",
			"display-country": "Falkland Islands (Malvinas)",
			"icon": "Falkland-Islands-(Malvinas).png"
		},
		{"states": [], "country": "FO", "display-country": "Faroe Islands", "icon": "Faroe-Islands.png"},
		{"states": [], "country": "FJ", "display-country": "Fiji", "icon": "Fiji.png"},
		{"states": [], "country": "FI", "display-country": "Finland", "icon": "Finland.png"},
		{"states": [], "country": "FR", "display-country": "France", "icon": "France.png"},
		{"states": [], "country": "GF", "display-country": "French Guiana", "icon": "French-Guiana.png"},
		{"states": [], "country": "PF", "display-country": "French Polynesia", "icon": "French-Polynesia.png"},
		{
			"states": [],
			"country": "TF",
			"display-country": "French Southern Territories",
			"icon": "French-Southern-Territories.png"
		},
		{"states": [], "country": "GA", "display-country": "Gabon", "icon": "Gabon.png"},
		{"states": [], "country": "GM", "display-country": "Gambia", "icon": "Gambia.png"},
		{"states": [], "country": "GE", "display-country": "Georgia", "icon": "Georgia.png"},
		{"states": [], "country": "DE", "display-country": "Germany", "icon": "Germany.png"},
		{"states": [], "country": "GH", "display-country": "Ghana", "icon": "Ghana.png"},
		{"states": [], "country": "GI", "display-country": "Gibraltar", "icon": "Gibraltar.png"},
		{"states": [], "country": "GR", "display-country": "Greece", "icon": "Greece.png"},
		{"states": [], "country": "GL", "display-country": "Greenland", "icon": "Greenland.png"},
		{"states": [], "country": "GD", "display-country": "Grenada", "icon": "Grenada.png"},
		{"states": [], "country": "GP", "display-country": "Guadeloupe", "icon": "Guadeloupe.png"},
		{
			"states": [{"state": "", "display-state": "Alta Verapaz"}, {
				"state": "",
				"display-state": "Baja Verapaz"
			}, {"state": "", "display-state": "Chimaltenango"}, {"state": "", "display-state": "Chiquimula"}, {
				"state": "",
				"display-state": "El Progreso"
			}, {"state": "", "display-state": "Escuintla"}, {"state": "", "display-state": "Guatemala"}, {
				"state": "",
				"display-state": "Huehuetenango"
			}, {"state": "", "display-state": "Izabal"}, {"state": "", "display-state": "Jalapa"}, {
				"state": "",
				"display-state": "Jutiapa"
			}, {"state": "", "display-state": "Pet\u00e9n"}, {"state": "", "display-state": "Quetzaltenango"}, {
				"state": "",
				"display-state": "Quich\u00e9"
			}, {"state": "", "display-state": "Retalhuleu"}, {
				"state": "",
				"display-state": "Sacatep\u00e9quez"
			}, {"state": "", "display-state": "San Marcos"}, {"state": "", "display-state": "Santa Rosa"}, {
				"state": "",
				"display-state": "Solol\u00e1"
			}, {"state": "", "display-state": "Suchitep\u00e9quez"}, {
				"state": "",
				"display-state": "Totonicap\u00e1n"
			}, {"state": "", "display-state": "Zacapa"}],
			"country": "GT",
			"display-country": "Guatemala",
			"icon": "Guatemala.png"
		},
		{"states": [], "country": "GG", "display-country": "Guernsey", "icon": "Guernsey.png"},
		{"states": [], "country": "GN", "display-country": "Guinea", "icon": "Guinea.png"},
		{"states": [], "country": "GW", "display-country": "Guinea Bissau", "icon": "Guinea-Bissau.png"},
		{"states": [], "country": "GY", "display-country": "Guyana", "icon": "Guyana.png"},
		{"states": [], "country": "HT", "display-country": "Haiti", "icon": "Haiti.png"},
		{
			"states": [],
			"country": "HM",
			"display-country": "Heard Island And Mcdonald Islands",
			"icon": "Heard-Island-And-Mcdonald-Islands.png"
		},
		{
			"states": [],
			"country": "VA",
			"display-country": "Holy See (Vatican City State)",
			"icon": "Holy-See-(Vatican-City-State).png"
		},
		{"states": [], "country": "HN", "display-country": "Honduras", "icon": "Honduras.png"},
		{"states": [], "country": "HK", "display-country": "Hong Kong", "icon": "Hong-Kong.png"},
		{"states": [], "country": "HU", "display-country": "Hungary", "icon": "Hungary.png"},
		{"states": [], "country": "IS", "display-country": "Iceland", "icon": "Iceland.png"},
		{
			"states": [{"state": "", "display-state": "Andaman and Nicobar"}, {
				"state": "",
				"display-state": "Andhra Pradesh"
			}, {"state": "", "display-state": "Arunachal Pradesh"}, {"state": "", "display-state": "Assam"}, {
				"state": "",
				"display-state": "Bihar"
			}, {"state": "", "display-state": "Chandigarh"}, {"state": "", "display-state": "Chattisgarh"}, {
				"state": "",
				"display-state": "Dadra and Nagar Haveli"
			}, {"state": "", "display-state": "Daman and Diu"}, {"state": "", "display-state": "Delhi"}, {
				"state": "",
				"display-state": "Goa"
			}, {"state": "", "display-state": "Gujarat"}, {"state": "", "display-state": "Haryana"}, {
				"state": "",
				"display-state": "Himachal Pradesh"
			}, {"state": "", "display-state": "Jammu and Kashmir"}, {
				"state": "",
				"display-state": "Jharkhand"
			}, {"state": "", "display-state": "Karnataka"}, {"state": "", "display-state": "Kerala"}, {
				"state": "",
				"display-state": "Lakshadweep"
			}, {"state": "", "display-state": "Madhya Pradesh"}, {
				"state": "",
				"display-state": "Maharashtra"
			}, {"state": "", "display-state": "Manipur"}, {"state": "", "display-state": "Meghalaya"}, {
				"state": "",
				"display-state": "Mizoram"
			}, {"state": "", "display-state": "Nagaland"}, {"state": "", "display-state": "Orissa"}, {
				"state": "",
				"display-state": "Puducherry"
			}, {"state": "", "display-state": "Punjab"}, {"state": "", "display-state": "Rajasthan"}, {
				"state": "",
				"display-state": "Sikkim"
			}, {"state": "", "display-state": "Tamil Nadu"}, {"state": "", "display-state": "Tripura"}, {
				"state": "",
				"display-state": "Uttar Pradesh"
			}, {"state": "", "display-state": "Uttarakhand"}, {"state": "", "display-state": "West Bengal"}],
			"country": "IN",
			"display-country": "India",
			"icon": "India.png"
		},
		{
			"states": [{"state": "", "display-state": "Aceh"}, {"state": "", "display-state": "Bali"}, {
				"state": "",
				"display-state": "Bangka Belitung"
			}, {"state": "", "display-state": "Banten"}, {"state": "", "display-state": "Bengkulu"}, {
				"state": "",
				"display-state": "Gorontalo"
			}, {"state": "", "display-state": "Jakarta"}, {"state": "", "display-state": "Jambi"}, {
				"state": "",
				"display-state": "Jawa Barat"
			}, {"state": "", "display-state": "Jawa Tengah"}, {"state": "", "display-state": "Jawa Timur"}, {
				"state": "",
				"display-state": "Kalimantan Barat"
			}, {"state": "", "display-state": "Kalimantan Selatan"}, {
				"state": "",
				"display-state": "Kalimantan Tengah"
			}, {"state": "", "display-state": "Kalimantan Timur"}, {
				"state": "",
				"display-state": "Kalimantan Utara"
			}, {"state": "", "display-state": "Kepulauan Riau"}, {"state": "", "display-state": "Lampung"}, {
				"state": "",
				"display-state": "Maluku"
			}, {"state": "", "display-state": "Maluku Utara"}, {
				"state": "",
				"display-state": "Nusa Tenggara Barat"
			}, {"state": "", "display-state": "Nusa Tenggara Timur"}, {"state": "", "display-state": "Papua"}, {
				"state": "",
				"display-state": "Papua Barat"
			}, {"state": "", "display-state": "Riau"}, {"state": "", "display-state": "Sulawesi Barat"}, {
				"state": "",
				"display-state": "Sulawesi Selatan"
			}, {"state": "", "display-state": "Sulawesi Tengah"}, {
				"state": "",
				"display-state": "Sulawesi Tenggara"
			}, {"state": "", "display-state": "Sulawesi Utara"}, {
				"state": "",
				"display-state": "Sumatra Barat"
			}, {"state": "", "display-state": "Sumatra Selatan"}, {
				"state": "",
				"display-state": "Sumatra Utara"
			}, {"state": "", "display-state": "Yogyakarta"}],
			"country": "ID",
			"display-country": "Indonesia",
			"icon": "Indonesia.png"
		},
		{
			"states": [],
			"country": "IR",
			"display-country": "Iran, Islamic Republic Of",
			"icon": "Iran,-Islamic-Republic-Of.png"
		},
		{"states": [], "country": "IQ", "display-country": "Iraq", "icon": "Iraq.png"},
		{"states": [], "country": "IE", "display-country": "Ireland", "icon": "Ireland.png"},
		{"states": [], "country": "IM", "display-country": "Isle Of Man", "icon": "Isle-Of-Man.png"},
		{"states": [], "country": "IL", "display-country": "Israel", "icon": "Israel.png"},
		{
			"states": [{"state": "", "display-state": "Agrigento"}, {
				"state": "",
				"display-state": "Alessandria"
			}, {"state": "", "display-state": "Ancona"}, {"state": "", "display-state": "Aosta"}, {
				"state": "",
				"display-state": "Arezzo"
			}, {"state": "", "display-state": "Ascoli Piceno"}, {"state": "", "display-state": "Asti"}, {
				"state": "",
				"display-state": "Avellino"
			}, {"state": "", "display-state": "Bari"}, {
				"state": "",
				"display-state": "Barletta-Andria-Trani"
			}, {"state": "", "display-state": "Belluno"}, {"state": "", "display-state": "Benevento"}, {
				"state": "",
				"display-state": "Bergamo"
			}, {"state": "", "display-state": "Biella"}, {"state": "", "display-state": "Bologna"}, {
				"state": "",
				"display-state": "Bolzano"
			}, {"state": "", "display-state": "Brescia"}, {"state": "", "display-state": "Brindisi"}, {
				"state": "",
				"display-state": "Cagliari"
			}, {"state": "", "display-state": "Caltanissetta"}, {"state": "", "display-state": "Campobasso"}, {
				"state": "",
				"display-state": "Carbonia-Iglesias"
			}, {"state": "", "display-state": "Caserta"}, {"state": "", "display-state": "Catania"}, {
				"state": "",
				"display-state": "Catanzaro"
			}, {"state": "", "display-state": "Chieti"}, {"state": "", "display-state": "Como"}, {
				"state": "",
				"display-state": "Cosenza"
			}, {"state": "", "display-state": "Cremona"}, {"state": "", "display-state": "Crotone"}, {
				"state": "",
				"display-state": "Cuneo"
			}, {"state": "", "display-state": "Enna"}, {"state": "", "display-state": "Fermo"}, {
				"state": "",
				"display-state": "Ferrara"
			}, {"state": "", "display-state": "Florence"}, {"state": "", "display-state": "Foggia"}, {
				"state": "",
				"display-state": "Forli-Cesena"
			}, {"state": "", "display-state": "Frosinone"}, {"state": "", "display-state": "Genoa"}, {
				"state": "",
				"display-state": "Gorizia"
			}, {"state": "", "display-state": "Grosseto"}, {"state": "", "display-state": "Imperia"}, {
				"state": "",
				"display-state": "Isernia"
			}, {"state": "", "display-state": "L&#39;Aquila"}, {"state": "", "display-state": "La Spezia"}, {
				"state": "",
				"display-state": "Latina"
			}, {"state": "", "display-state": "Lecce"}, {"state": "", "display-state": "Lecco"}, {
				"state": "",
				"display-state": "Livorno"
			}, {"state": "", "display-state": "Lodi"}, {"state": "", "display-state": "Lucca"}, {
				"state": "",
				"display-state": "Macerata"
			}, {"state": "", "display-state": "Mantua"}, {"state": "", "display-state": "Massa and Carrara"}, {
				"state": "",
				"display-state": "Matera"
			}, {"state": "", "display-state": "Medio Campidano"}, {"state": "", "display-state": "Messina"}, {
				"state": "",
				"display-state": "Milan"
			}, {"state": "", "display-state": "Modena"}, {"state": "", "display-state": "Monza and Brianza"}, {
				"state": "",
				"display-state": "Naples"
			}, {"state": "", "display-state": "Novara"}, {"state": "", "display-state": "Nuoro"}, {
				"state": "",
				"display-state": "Ogliastra"
			}, {"state": "", "display-state": "Olbia-Tempio"}, {"state": "", "display-state": "Oristano"}, {
				"state": "",
				"display-state": "Padua"
			}, {"state": "", "display-state": "Palermo"}, {"state": "", "display-state": "Parma"}, {
				"state": "",
				"display-state": "Pavia"
			}, {"state": "", "display-state": "Perugia"}, {"state": "", "display-state": "Pesaro and Urbino"}, {
				"state": "",
				"display-state": "Pescara"
			}, {"state": "", "display-state": "Piacenza"}, {"state": "", "display-state": "Pisa"}, {
				"state": "",
				"display-state": "Pistoia"
			}, {"state": "", "display-state": "Pordenone"}, {"state": "", "display-state": "Potenza"}, {
				"state": "",
				"display-state": "Prato"
			}, {"state": "", "display-state": "Ragusa"}, {"state": "", "display-state": "Ravenna"}, {
				"state": "",
				"display-state": "Reggio Calabria"
			}, {"state": "", "display-state": "Reggio Emilia"}, {"state": "", "display-state": "Rieti"}, {
				"state": "",
				"display-state": "Rimini"
			}, {"state": "", "display-state": "Rome"}, {"state": "", "display-state": "Rovigo"}, {
				"state": "",
				"display-state": "Salerno"
			}, {"state": "", "display-state": "Sassari"}, {"state": "", "display-state": "Savona"}, {
				"state": "",
				"display-state": "Siena"
			}, {"state": "", "display-state": "Sondrio"}, {"state": "", "display-state": "Syracuse"}, {
				"state": "",
				"display-state": "Taranto"
			}, {"state": "", "display-state": "Teramo"}, {"state": "", "display-state": "Terni"}, {
				"state": "",
				"display-state": "Trapani"
			}, {"state": "", "display-state": "Trento"}, {"state": "", "display-state": "Treviso"}, {
				"state": "",
				"display-state": "Trieste"
			}, {"state": "", "display-state": "Turin"}, {"state": "", "display-state": "Udine"}, {
				"state": "",
				"display-state": "Varese"
			}, {"state": "", "display-state": "Venice"}, {
				"state": "",
				"display-state": "Verbano-Cusio-Ossola"
			}, {"state": "", "display-state": "Vercelli"}, {"state": "", "display-state": "Verona"}, {
				"state": "",
				"display-state": "Vibo Valentia"
			}, {"state": "", "display-state": "Vicenza"}, {"state": "", "display-state": "Viterbo"}],
			"country": "IT",
			"display-country": "Italy",
			"icon": "Italy.png"
		},
		{"states": [], "country": "JM", "display-country": "Jamaica", "icon": "Jamaica.png"},
		{"states": [], "country": "JP", "display-country": "Japan", "icon": "Japan.png"},
		{"states": [], "country": "JE", "display-country": "Jersey", "icon": "Jersey.png"},
		{"states": [], "country": "JO", "display-country": "Jordan", "icon": "Jordan.png"},
		{"states": [], "country": "KZ", "display-country": "Kazakhstan", "icon": "Kazakhstan.png"},
		{"states": [], "country": "KE", "display-country": "Kenya", "icon": "Kenya.png"},
		{"states": [], "country": "KI", "display-country": "Kiribati", "icon": "Kiribati.png"},
		{
			"states": [],
			"country": "KP",
			"display-country": "Korea, Democratic People's Republic Of",
			"icon": "Korea,-Democratic-People's-Republic-Of.png"
		},
		{"states": [], "country": "XK", "display-country": "Kosovo", "icon": "Kosovo.png"},
		{"states": [], "country": "KW", "display-country": "Kuwait", "icon": "Kuwait.png"},
		{"states": [], "country": "KG", "display-country": "Kyrgyzstan", "icon": "Kyrgyzstan.png"},
		{
			"states": [],
			"country": "LA",
			"display-country": "Lao People's Democratic Republic",
			"icon": "Lao-People's-Democratic-Republic.png"
		},
		{"states": [], "country": "LV", "display-country": "Latvia", "icon": "Latvia.png"},
		{"states": [], "country": "LB", "display-country": "Lebanon", "icon": "Lebanon.png"},
		{"states": [], "country": "LS", "display-country": "Lesotho", "icon": "Lesotho.png"},
		{"states": [], "country": "LR", "display-country": "Liberia", "icon": "Liberia.png"},
		{
			"states": [],
			"country": "LY",
			"display-country": "Libyan Arab Jamahiriya",
			"icon": "Libyan-Arab-Jamahiriya.png"
		},
		{"states": [], "country": "LI", "display-country": "Liechtenstein", "icon": "Liechtenstein.png"},
		{"states": [], "country": "LT", "display-country": "Lithuania", "icon": "Lithuania.png"},
		{"states": [], "country": "LU", "display-country": "Luxembourg", "icon": "Luxembourg.png"},
		{"states": [], "country": "MO", "display-country": "Macao", "icon": "Macao.png"},
		{
			"states": [],
			"country": "MK",
			"display-country": "Macedonia, Republic Of",
			"icon": "Macedonia,-Republic-Of.png"
		},
		{"states": [], "country": "MG", "display-country": "Madagascar", "icon": "Madagascar.png"},
		{"states": [], "country": "MW", "display-country": "Malawi", "icon": "Malawi.png"},
		{
			"states": [{"state": "", "display-state": "Johor"}, {"state": "", "display-state": "Kedah"}, {
				"state": "",
				"display-state": "Kelantan"
			}, {"state": "", "display-state": "Kuala Lumpur"}, {"state": "", "display-state": "Labuan"}, {
				"state": "",
				"display-state": "Melaka"
			}, {"state": "", "display-state": "Negeri Sembilan"}, {"state": "", "display-state": "Pahang"}, {
				"state": "",
				"display-state": "Perak"
			}, {"state": "", "display-state": "Perlis"}, {"state": "", "display-state": "Pulau Pinang"}, {
				"state": "",
				"display-state": "Putrajaya"
			}, {"state": "", "display-state": "Sabah"}, {"state": "", "display-state": "Sarawak"}, {
				"state": "",
				"display-state": "Selangor"
			}, {"state": "", "display-state": "Terengganu"}],
			"country": "MY",
			"display-country": "Malaysia",
			"icon": "Malaysia.png"
		},
		{"states": [], "country": "MV", "display-country": "Maldives", "icon": "Maldives.png"},
		{"states": [], "country": "ML", "display-country": "Mali", "icon": "Mali.png"},
		{"states": [], "country": "MT", "display-country": "Malta", "icon": "Malta.png"},
		{"states": [], "country": "MQ", "display-country": "Martinique", "icon": "Martinique.png"},
		{"states": [], "country": "MR", "display-country": "Mauritania", "icon": "Mauritania.png"},
		{"states": [], "country": "MU", "display-country": "Mauritius", "icon": "Mauritius.png"},
		{"states": [], "country": "YT", "display-country": "Mayotte", "icon": "Mayotte.png"},
		{
			"states": [{"state": "", "display-state": "Aguascalientes"}, {
				"state": "",
				"display-state": "Baja California"
			}, {"state": "", "display-state": "Baja California Sur"}, {
				"state": "",
				"display-state": "Campeche"
			}, {"state": "", "display-state": "Chiapas"}, {"state": "", "display-state": "Chihuahua"}, {
				"state": "",
				"display-state": "Coahuila"
			}, {"state": "", "display-state": "Colima"}, {"state": "", "display-state": "Distrito Federal"}, {
				"state": "",
				"display-state": "Durango"
			}, {"state": "", "display-state": "Guanajuato"}, {"state": "", "display-state": "Guerrero"}, {
				"state": "",
				"display-state": "Hidalgo"
			}, {"state": "", "display-state": "Jalisco"}, {"state": "", "display-state": "Michoac\u00e1n"}, {
				"state": "",
				"display-state": "Morelos"
			}, {"state": "", "display-state": "M\u00e9xico"}, {"state": "", "display-state": "Nayarit"}, {
				"state": "",
				"display-state": "Nuevo Le\u00f3n"
			}, {"state": "", "display-state": "Oaxaca"}, {"state": "", "display-state": "Puebla"}, {
				"state": "",
				"display-state": "Quer\u00e9taro"
			}, {"state": "", "display-state": "Quintana Roo"}, {
				"state": "",
				"display-state": "San Luis Potos\u00ed"
			}, {"state": "", "display-state": "Sinaloa"}, {"state": "", "display-state": "Sonora"}, {
				"state": "",
				"display-state": "Tabasco"
			}, {"state": "", "display-state": "Tamaulipas"}, {"state": "", "display-state": "Tlaxcala"}, {
				"state": "",
				"display-state": "Veracruz"
			}, {"state": "", "display-state": "Yucat\u00e1n"}, {"state": "", "display-state": "Zacatecas"}],
			"country": "MX",
			"display-country": "Mexico",
			"icon": "Mexico.png"
		},
		{"states": [], "country": "MD", "display-country": "Moldova, Republic of", "icon": "Moldova,-Republic-of.png"},
		{"states": [], "country": "MC", "display-country": "Monaco", "icon": "Monaco.png"},
		{"states": [], "country": "MN", "display-country": "Mongolia", "icon": "Mongolia.png"},
		{"states": [], "country": "ME", "display-country": "Montenegro", "icon": "Montenegro.png"},
		{"states": [], "country": "MS", "display-country": "Montserrat", "icon": "Montserrat.png"},
		{"states": [], "country": "MA", "display-country": "Morocco", "icon": "Morocco.png"},
		{"states": [], "country": "MZ", "display-country": "Mozambique", "icon": "Mozambique.png"},
		{"states": [], "country": "NA", "display-country": "Namibia", "icon": "Namibia.png"},
		{"states": [], "country": "NR", "display-country": "Nauru", "icon": "Nauru.png"},
		{"states": [], "country": "NP", "display-country": "Nepal", "icon": "Nepal.png"},
		{"states": [], "country": "NL", "display-country": "Netherlands", "icon": "Netherlands.png"},
		{"states": [], "country": "AN", "display-country": "Netherlands Antilles", "icon": "Netherlands-Antilles.png"},
		{"states": [], "country": "NC", "display-country": "New Caledonia", "icon": "New-Caledonia.png"},
		{
			"states": [{"state": "", "display-state": "Auckland"}, {
				"state": "",
				"display-state": "Bay of Plenty"
			}, {"state": "", "display-state": "Canterbury"}, {"state": "", "display-state": "Gisborne"}, {
				"state": "",
				"display-state": "Hawke's Bay"
			}, {"state": "", "display-state": "Manawatu-Wanganui"}, {
				"state": "",
				"display-state": "Marlborough"
			}, {"state": "", "display-state": "Nelson"}, {"state": "", "display-state": "Northland"}, {
				"state": "",
				"display-state": "Otago"
			}, {"state": "", "display-state": "Southland"}, {"state": "", "display-state": "Taranaki"}, {
				"state": "",
				"display-state": "Tasman"
			}, {"state": "", "display-state": "Waikato"}, {"state": "", "display-state": "Wellington"}, {
				"state": "",
				"display-state": "West Coast"
			}], "country": "NZ", "display-country": "New Zealand", "icon": "New-Zealand.png"
		},
		{"states": [], "country": "NI", "display-country": "Nicaragua", "icon": "Nicaragua.png"},
		{"states": [], "country": "NE", "display-country": "Niger", "icon": "Niger.png"},
		{"states": [], "country": "NG", "display-country": "Nigeria", "icon": "Nigeria.png"},
		{"states": [], "country": "NU", "display-country": "Niue", "icon": "Niue.png"},
		{"states": [], "country": "NF", "display-country": "Norfolk Island", "icon": "Norfolk-Island.png"},
		{"states": [], "country": "NO", "display-country": "Norway", "icon": "Norway.png"},
		{"states": [], "country": "OM", "display-country": "Oman", "icon": "Oman.png"},
		{"states": [], "country": "PK", "display-country": "Pakistan", "icon": "Pakistan.png"},
		{
			"states": [],
			"country": "PS",
			"display-country": "Palestinian Territory, Occupied",
			"icon": "Palestinian-Territory,-Occupied.png"
		},
		{"states": [], "country": "PA", "display-country": "Panama", "icon": "Panama.png"},
		{"states": [], "country": "PG", "display-country": "Papua New Guinea", "icon": "Papua-New-Guinea.png"},
		{"states": [], "country": "PY", "display-country": "Paraguay", "icon": "Paraguay.png"},
		{"states": [], "country": "PE", "display-country": "Peru", "icon": "Peru.png"},
		{"states": [], "country": "PH", "display-country": "Philippines", "icon": "Philippines.png"},
		{"states": [], "country": "PN", "display-country": "Pitcairn", "icon": "Pitcairn.png"},
		{"states": [], "country": "PL", "display-country": "Poland", "icon": "Poland.png"},
		{
			"states": [{"state": "", "display-state": "Aveiro"}, {
				"state": "",
				"display-state": "A\u00e7ores"
			}, {"state": "", "display-state": "Beja"}, {"state": "", "display-state": "Braga"}, {
				"state": "",
				"display-state": "Bragan\u00e7a"
			}, {"state": "", "display-state": "Castelo Branco"}, {"state": "", "display-state": "Coimbra"}, {
				"state": "",
				"display-state": "Faro"
			}, {"state": "", "display-state": "Guarda"}, {"state": "", "display-state": "Leiria"}, {
				"state": "",
				"display-state": "Lisboa"
			}, {"state": "", "display-state": "Madeira"}, {"state": "", "display-state": "Portalegre"}, {
				"state": "",
				"display-state": "Porto"
			}, {"state": "", "display-state": "Santar\u00e9m"}, {
				"state": "",
				"display-state": "Set\u00fabal"
			}, {"state": "", "display-state": "Viana do Castelo"}, {
				"state": "",
				"display-state": "Vila Real"
			}, {"state": "", "display-state": "Viseu"}, {"state": "", "display-state": "\u00c9vora"}],
			"country": "PT",
			"display-country": "Portugal",
			"icon": "Portugal.png"
		},
		{"states": [], "country": "QA", "display-country": "Qatar", "icon": "Qatar.png"},
		{"states": [], "country": "CM", "display-country": "Republic of Cameroon", "icon": "Republic-of-Cameroon.png"},
		{"states": [], "country": "RE", "display-country": "Reunion", "icon": "Reunion.png"},
		{"states": [], "country": "RO", "display-country": "Romania", "icon": "Romania.png"},
		{
			"states": [{"state": "", "display-state": "Altai Krai"}, {
				"state": "",
				"display-state": "Altai Republic"
			}, {"state": "", "display-state": "Amur Oblast"}, {
				"state": "",
				"display-state": "Arkhangelsk Oblast"
			}, {"state": "", "display-state": "Astrakhan Oblast"}, {
				"state": "",
				"display-state": "Belgorod Oblast"
			}, {"state": "", "display-state": "Bryansk Oblast"}, {
				"state": "",
				"display-state": "Chechen Republic"
			}, {"state": "", "display-state": "Chelyabinsk Oblast"}, {
				"state": "",
				"display-state": "Chukotka Autonomous Okrug"
			}, {"state": "", "display-state": "Chuvash Republic"}, {
				"state": "",
				"display-state": "Irkutsk Oblast"
			}, {"state": "", "display-state": "Ivanovo Oblast"}, {
				"state": "",
				"display-state": "Jewish Autonomous Oblast"
			}, {"state": "", "display-state": "Kabardino-Balkarian Republic"}, {
				"state": "",
				"display-state": "Kaliningrad Oblast"
			}, {"state": "", "display-state": "Kaluga Oblast"}, {
				"state": "",
				"display-state": "Kamchatka Krai"
			}, {"state": "", "display-state": "Karachay\u2013Cherkess Republic"}, {
				"state": "",
				"display-state": "Kemerovo Oblast"
			}, {"state": "", "display-state": "Khabarovsk Krai"}, {
				"state": "",
				"display-state": "Khanty-Mansi Autonomous Okrug"
			}, {"state": "", "display-state": "Kirov Oblast"}, {
				"state": "",
				"display-state": "Komi Republic"
			}, {"state": "", "display-state": "Kostroma Oblast"}, {
				"state": "",
				"display-state": "Krasnodar Krai"
			}, {"state": "", "display-state": "Krasnoyarsk Krai"}, {
				"state": "",
				"display-state": "Kurgan Oblast"
			}, {"state": "", "display-state": "Kursk Oblast"}, {
				"state": "",
				"display-state": "Leningrad Oblast"
			}, {"state": "", "display-state": "Lipetsk Oblast"}, {
				"state": "",
				"display-state": "Magadan Oblast"
			}, {"state": "", "display-state": "Mari El Republic"}, {"state": "", "display-state": "Moscow"}, {
				"state": "",
				"display-state": "Moscow Oblast"
			}, {"state": "", "display-state": "Murmansk Oblast"}, {
				"state": "",
				"display-state": "Nizhny Novgorod Oblast"
			}, {"state": "", "display-state": "Novgorod Oblast"}, {
				"state": "",
				"display-state": "Novosibirsk Oblast"
			}, {"state": "", "display-state": "Omsk Oblast"}, {
				"state": "",
				"display-state": "Orenburg Oblast"
			}, {"state": "", "display-state": "Oryol Oblast"}, {"state": "", "display-state": "Penza Oblast"}, {
				"state": "",
				"display-state": "Perm Krai"
			}, {"state": "", "display-state": "Primorsky Krai"}, {
				"state": "",
				"display-state": "Pskov Oblast"
			}, {"state": "", "display-state": "Republic of Adygeya"}, {
				"state": "",
				"display-state": "Republic of Bashkortostan"
			}, {"state": "", "display-state": "Republic of Buryatia"}, {
				"state": "",
				"display-state": "Republic of Dagestan"
			}, {"state": "", "display-state": "Republic of Ingushetia"}, {
				"state": "",
				"display-state": "Republic of Kalmykia"
			}, {"state": "", "display-state": "Republic of Karelia"}, {
				"state": "",
				"display-state": "Republic of Khakassia"
			}, {"state": "", "display-state": "Republic of Mordovia"}, {
				"state": "",
				"display-state": "Republic of North Ossetia\u2013Alania"
			}, {"state": "", "display-state": "Republic of Tatarstan"}, {
				"state": "",
				"display-state": "Rostov Oblast"
			}, {"state": "", "display-state": "Ryazan Oblast"}, {
				"state": "",
				"display-state": "Saint Petersburg"
			}, {"state": "", "display-state": "Sakha Republic (Yakutia)"}, {
				"state": "",
				"display-state": "Sakhalin Oblast"
			}, {"state": "", "display-state": "Samara Oblast"}, {
				"state": "",
				"display-state": "Saratov Oblast"
			}, {"state": "", "display-state": "Smolensk Oblast"}, {
				"state": "",
				"display-state": "Stavropol Krai"
			}, {"state": "", "display-state": "Sverdlovsk Oblast"}, {
				"state": "",
				"display-state": "Tambov Oblast"
			}, {"state": "", "display-state": "Tomsk Oblast"}, {"state": "", "display-state": "Tula Oblast"}, {
				"state": "",
				"display-state": "Tver Oblast"
			}, {"state": "", "display-state": "Tyumen Oblast"}, {
				"state": "",
				"display-state": "Tyva Republic"
			}, {"state": "", "display-state": "Udmurtia"}, {"state": "", "display-state": "Ulyanovsk Oblast"}, {
				"state": "",
				"display-state": "Vladimir Oblast"
			}, {"state": "", "display-state": "Volgograd Oblast"}, {
				"state": "",
				"display-state": "Vologda Oblast"
			}, {"state": "", "display-state": "Voronezh Oblast"}, {
				"state": "",
				"display-state": "Yamalo-Nenets Autonomous Okrug"
			}, {"state": "", "display-state": "Yaroslavl Oblast"}],
			"country": "RU",
			"display-country": "Russia",
			"icon": "Russia.png"
		},
		{"states": [], "country": "RW", "display-country": "Rwanda", "icon": "Rwanda.png"},
		{
			"states": [],
			"country": "BL",
			"display-country": "Saint Barth\u00e9lemy",
			"icon": "Saint-Barth\u00e9lemy.png"
		},
		{"states": [], "country": "SH", "display-country": "Saint Helena", "icon": "Saint-Helena.png"},
		{
			"states": [],
			"country": "KN",
			"display-country": "Saint Kitts And Nevis",
			"icon": "Saint-Kitts-And-Nevis.png"
		},
		{"states": [], "country": "LC", "display-country": "Saint Lucia", "icon": "Saint-Lucia.png"},
		{"states": [], "country": "MF", "display-country": "Saint Martin", "icon": "Saint-Martin.png"},
		{
			"states": [],
			"country": "PM",
			"display-country": "Saint Pierre And Miquelon",
			"icon": "Saint-Pierre-And-Miquelon.png"
		},
		{"states": [], "country": "WS", "display-country": "Samoa", "icon": "Samoa.png"},
		{"states": [], "country": "SM", "display-country": "San Marino", "icon": "San-Marino.png"},
		{
			"states": [],
			"country": "ST",
			"display-country": "Sao Tome And Principe",
			"icon": "Sao-Tome-And-Principe.png"
		},
		{"states": [], "country": "SA", "display-country": "Saudi Arabia", "icon": "Saudi-Arabia.png"},
		{"states": [], "country": "SN", "display-country": "Senegal", "icon": "Senegal.png"},
		{"states": [], "country": "RS", "display-country": "Serbia", "icon": "Serbia.png"},
		{"states": [], "country": "SC", "display-country": "Seychelles", "icon": "Seychelles.png"},
		{"states": [], "country": "SL", "display-country": "Sierra Leone", "icon": "Sierra-Leone.png"},
		{"states": [], "country": "SG", "display-country": "Singapore", "icon": "Singapore.png"},
		{"states": [], "country": "SK", "display-country": "Slovakia", "icon": "Slovakia.png"},
		{"states": [], "country": "SI", "display-country": "Slovenia", "icon": "Slovenia.png"},
		{"states": [], "country": "SB", "display-country": "Solomon Islands", "icon": "Solomon-Islands.png"},
		{"states": [], "country": "SO", "display-country": "Somalia", "icon": "Somalia.png"},
		{
			"states": [{"state": "", "display-state": "Eastern Cape"}, {
				"state": "",
				"display-state": "Free State"
			}, {"state": "", "display-state": "Gauteng"}, {"state": "", "display-state": "KwaZulu-Natal"}, {
				"state": "",
				"display-state": "Limpopo"
			}, {"state": "", "display-state": "Mpumalanga"}, {"state": "", "display-state": "North West"}, {
				"state": "",
				"display-state": "Northern Cape"
			}, {"state": "", "display-state": "Western Cape"}],
			"country": "ZA",
			"display-country": "South Africa",
			"icon": "South-Africa.png"
		},
		{
			"states": [],
			"country": "GS",
			"display-country": "South Georgia And The South Sandwich Islands",
			"icon": "South-Georgia-And-The-South-Sandwich-Islands.png"
		},
		{"states": [], "country": "KR", "display-country": "South Korea", "icon": "South-Korea.png"},
		{
			"states": [{"state": "", "display-state": "A Coru\u00f1a"}, {
				"state": "",
				"display-state": "Albacete"
			}, {"state": "", "display-state": "Alicante"}, {"state": "", "display-state": "Almer\u00eda"}, {
				"state": "",
				"display-state": "Asturias"
			}, {"state": "", "display-state": "Badajoz"}, {"state": "", "display-state": "Baleares"}, {
				"state": "",
				"display-state": "Barcelona"
			}, {"state": "", "display-state": "Burgos"}, {"state": "", "display-state": "Cantabria"}, {
				"state": "",
				"display-state": "Castell\u00f3n"
			}, {"state": "", "display-state": "Ceuta"}, {"state": "", "display-state": "Ciudad Real"}, {
				"state": "",
				"display-state": "Cuenca"
			}, {"state": "", "display-state": "C\u00e1ceres"}, {"state": "", "display-state": "C\u00e1diz"}, {
				"state": "",
				"display-state": "C\u00f3rdoba"
			}, {"state": "", "display-state": "Girona"}, {"state": "", "display-state": "Granada"}, {
				"state": "",
				"display-state": "Guadalajara"
			}, {"state": "", "display-state": "Guip\u00fazcoa"}, {"state": "", "display-state": "Huelva"}, {
				"state": "",
				"display-state": "Huesca"
			}, {"state": "", "display-state": "Ja\u00e9n"}, {"state": "", "display-state": "La Rioja"}, {
				"state": "",
				"display-state": "Las Palmas"
			}, {"state": "", "display-state": "Le\u00f3n"}, {"state": "", "display-state": "Lleida"}, {
				"state": "",
				"display-state": "Lugo"
			}, {"state": "", "display-state": "Madrid"}, {"state": "", "display-state": "Melilla"}, {
				"state": "",
				"display-state": "Murcia"
			}, {"state": "", "display-state": "M\u00e1laga"}, {"state": "", "display-state": "Navarra"}, {
				"state": "",
				"display-state": "Ourense"
			}, {"state": "", "display-state": "Palencia"}, {"state": "", "display-state": "Pontevedra"}, {
				"state": "",
				"display-state": "Salamanca"
			}, {"state": "", "display-state": "Santa Cruz de Tenerife"}, {
				"state": "",
				"display-state": "Segovia"
			}, {"state": "", "display-state": "Sevilla"}, {"state": "", "display-state": "Soria"}, {
				"state": "",
				"display-state": "Tarragona"
			}, {"state": "", "display-state": "Teruel"}, {"state": "", "display-state": "Toledo"}, {
				"state": "",
				"display-state": "Valencia"
			}, {"state": "", "display-state": "Valladolid"}, {"state": "", "display-state": "Vizcaya"}, {
				"state": "",
				"display-state": "Zamora"
			}, {"state": "", "display-state": "Zaragoza"}, {"state": "", "display-state": "\u00c1lava"}, {
				"state": "",
				"display-state": "\u00c1vila"
			}], "country": "ES", "display-country": "Spain", "icon": "Spain.png"
		},
		{"states": [], "country": "LK", "display-country": "Sri Lanka", "icon": "Sri-Lanka.png"},
		{"states": [], "country": "VC", "display-country": "St. Vincent", "icon": "St.-Vincent.png"},
		{"states": [], "country": "SD", "display-country": "Sudan", "icon": "Sudan.png"},
		{"states": [], "country": "SR", "display-country": "Suriname", "icon": "Suriname.png"},
		{
			"states": [],
			"country": "SJ",
			"display-country": "Svalbard And Jan Mayen",
			"icon": "Svalbard-And-Jan-Mayen.png"
		},
		{"states": [], "country": "SZ", "display-country": "Swaziland", "icon": "Swaziland.png"},
		{"states": [], "country": "SE", "display-country": "Sweden", "icon": "Sweden.png"},
		{"states": [], "country": "CH", "display-country": "Switzerland", "icon": "Switzerland.png"},
		{"states": [], "country": "SY", "display-country": "Syria", "icon": "Syria.png"},
		{"states": [], "country": "TW", "display-country": "Taiwan", "icon": "Taiwan.png"},
		{"states": [], "country": "TJ", "display-country": "Tajikistan", "icon": "Tajikistan.png"},
		{
			"states": [],
			"country": "TZ",
			"display-country": "Tanzania, United Republic Of",
			"icon": "Tanzania,-United-Republic-Of.png"
		},
		{"states": [], "country": "TH", "display-country": "Thailand", "icon": "Thailand.png"},
		{"states": [], "country": "TL", "display-country": "Timor Leste", "icon": "Timor-Leste.png"},
		{"states": [], "country": "TG", "display-country": "Togo", "icon": "Togo.png"},
		{"states": [], "country": "TK", "display-country": "Tokelau", "icon": "Tokelau.png"},
		{"states": [], "country": "TO", "display-country": "Tonga", "icon": "Tonga.png"},
		{"states": [], "country": "TT", "display-country": "Trinidad and Tobago", "icon": "Trinidad-and-Tobago.png"},
		{"states": [], "country": "TN", "display-country": "Tunisia", "icon": "Tunisia.png"},
		{"states": [], "country": "TR", "display-country": "Turkey", "icon": "Turkey.png"},
		{"states": [], "country": "TM", "display-country": "Turkmenistan", "icon": "Turkmenistan.png"},
		{
			"states": [],
			"country": "TC",
			"display-country": "Turks and Caicos Islands",
			"icon": "Turks-and-Caicos-Islands.png"
		},
		{"states": [], "country": "TV", "display-country": "Tuvalu", "icon": "Tuvalu.png"},
		{"states": [], "country": "UG", "display-country": "Uganda", "icon": "Uganda.png"},
		{"states": [], "country": "UA", "display-country": "Ukraine", "icon": "Ukraine.png"},
		{
			"states": [{"state": "", "display-state": "Abu Dhabi"}, {"state": "", "display-state": "Ajman"}, {
				"state": "",
				"display-state": "Dubai"
			}, {"state": "", "display-state": "Fujairah"}, {"state": "", "display-state": "Ras al-Khaimah"}, {
				"state": "",
				"display-state": "Sharjah"
			}, {"state": "", "display-state": "Umm al-Quwain"}],
			"country": "AE",
			"display-country": "United Arab Emirates",
			"icon": "United-Arab-Emirates.png"
		},
		{"states": [], "country": "GB", "display-country": "United Kingdom", "icon": "United-Kingdom.png"},
		{
			"states": [],
			"country": "UM",
			"display-country": "United States Minor Outlying Islands",
			"icon": "United-States-Minor-Outlying-Islands.png"
		},
		{"states": [], "country": "UY", "display-country": "Uruguay", "icon": "Uruguay.png"},
		{"states": [], "country": "UZ", "display-country": "Uzbekistan", "icon": "Uzbekistan.png"},
		{"states": [], "country": "VU", "display-country": "Vanuatu", "icon": "Vanuatu.png"},
		{"states": [], "country": "VE", "display-country": "Venezuela", "icon": "Venezuela.png"},
		{"states": [], "country": "VN", "display-country": "Vietnam", "icon": "Vietnam.png"},
		{
			"states": [],
			"country": "VG",
			"display-country": "Virgin Islands, British",
			"icon": "Virgin-Islands,-British.png"
		},
		{"states": [], "country": "WF", "display-country": "Wallis And Futuna", "icon": "Wallis-And-Futuna.png"},
		{"states": [], "country": "EH", "display-country": "Western Sahara", "icon": "Western-Sahara.png"},
		{"states": [], "country": "YE", "display-country": "Yemen", "icon": "Yemen.png"},
		{"states": [], "country": "ZM", "display-country": "Zambia", "icon": "Zambia.png"},
		{"states": [], "country": "ZW", "display-country": "Zimbabwe", "icon": "Zimbabwe.png"},
		{"display-country": "Everywhere Else", "country": "Unknown", "states": [], "icon": "Unknown.png"},
		{"display-country": "Rest of World", "country": "Rest of World", "states": [], "icon": "World.png"}
	];
});
